import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AssetListReport  {
    _originalTypeClassName = "zERP.BO.AssetListReport";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AssetListReport.translate = translateService;
}
this.Assets = [];
this.From = null;
this.To = null;
this.Base = null;
this.AssetListReportKey = null;
this._key = this.AssetListReportKey = 0; 
}

static translate: TranslateService;
_key: any;
From:any;
To:any;
Base:any;
Assets:any;
private _AssetListReportKey:any;
get AssetListReportKey(): any {
    return this._AssetListReportKey;
  }
set AssetListReportKey(value: any) {
    this._AssetListReportKey = value;
    this._key = value;
  }
static setAssets = ($this, items) => {
                if (items == null) items = [];
                if ($this.Assets == null) $this.Assets = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Assets.length > 0) {
                    Domain.AssetListReport.removeAssets($this, $this.Assets[0]);
                }

                Domain.AssetListReport.addManyAssets($this, copyItems);
            }
static addManyAssets = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AssetListReport.addAssets($this, items[i]);
                }
            }
static addAssets = ($this, item) => {
                if ($this.Assets == null) $this.Assets = [];
                if (item == null || $this.Assets.indexOf(item) > -1) return;
                $this.Assets.push(item);
}
static addRangeAssets = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AssetListReport.addAssets($this, item));
            }
static removeAssets = ($this, item) => {
                if ($this == null || $this.Assets == null || $this.Assets.indexOf(item) === -1) return;
                var _index = $this.Assets.indexOf(item);
                $this.Assets.splice(_index, 1);
}
static clearAssets = ($this) => { $this.Assets = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AssetListReportKey == null || $this.AssetListReportKey == 0;
            }


}